import stepsActionsConstants from '../constants/stepsActionsConstants';

const initialState = {
  currentStep: null,
  loading: false,
};

const stepsReducer = (state = initialState, action) => {
  switch (action.type) {
    case stepsActionsConstants.GET_STEP:
      return {
        ...state,
        loading: true,
      };
    case stepsActionsConstants.GET_STEP_SUCCESS:
      return {
        ...state,
        currentStep: action.payload,
        loading: false,
      };
    default:
      return state;
  }
};

export default stepsReducer;
